<template>
  <div>

    <!--  导入商品 exportProduct-->
    <el-card>
      <div style="float: left;margin-left:20px;">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="供应商选择">
            <el-select @change="getProList" style="margin-left:10px;margin-bottom:10px;" clearable
                       v-model="searchData.ResellerId" placeholder="请选择供应商">
              <el-option
                  v-for="item in supplierList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="float:right;margin-right:50px;">
        <el-button type="success" @click="importFromUs">从自有商品库导入</el-button>
        <el-button type="success" @click="importFromYKT">从营客通商品库导入</el-button>
<!--        <el-button type="success" @click="tellRule">分销规则说明</el-button>-->
      </div>

    </el-card>
    <div style="margin-top:10px;">
      <el-form @submit.native.prevent inline label-width="100px">
        <el-form-item label="SkuId:">
          <el-input v-model="searchData.SkuIds" placeholder="SkuId"></el-input>
        </el-form-item>
        <!--        <el-form-item label="远程skuId:">-->
        <!--          <el-input v-model="searchData.RemoteIds" placeholder="子订单号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="商品名称:">
          <el-input v-model="searchData.ProName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select v-model="searchData.ChannelType" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="searchData.IsShelves" placeholder="请选择">
            <el-option
                v-for="item in options1"
                :key="item.label"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--      <el-form-item label="订单状态">-->
        <!--        <el-input v-model="searchData.OutOrderNo" placeholder="请输入"></el-input>-->
        <!--      </el-form-item>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="供应商" prop="ResellerId">-->
        <!--                  <el-select v-model="searchData.ResellerId" filterable remote placeholder="请选择 / 可搜索"-->
        <!--                             :remote-method="querySupplier" style="width:100%">-->
        <!--                    <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">-->
        <!--                    </el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--        </el-col>-->
        <!--      <el-form-item label="支付时间：">-->
        <!--        <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"-->
        <!--                        style="width:100%">-->
        <!--        </el-date-picker>-->
        <!--      </el-form-item>-->
        <!--        <el-form-item label="采购单号:">-->
        <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <div style="display: flex;">
            <el-button size="small" type="primary" @click="searchFun">查询</el-button>
            <el-button size="small" @click="resetFun">重置</el-button>
            <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
          </div>
        </el-form-item>
      </el-form>
      <div style="margin:10px;">
        <el-button size="small" type="primary" @click="batchDelete">批量移除</el-button>
        <el-button size="small" type="primary" @click="setPrice">批量设置分销价</el-button>
        <el-button size="small" type="primary" @click="exporting">导出</el-button>
      </div>
      <el-table v-loading="tableLoading" @selection-change="selectCurrentRow" :data="tableList" highlight-current-row
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%" border>
        <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
        <el-table-column prop="channelType" label="渠道" width="300" align="center">
        </el-table-column>
        <el-table-column label="销售价" prop="businessPrice" align="center" width="120">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;">{{-->
          <!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
          <!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column label="分销价" prop='distributionPrice' align="center" width="120">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;">{{-->
          <!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
          <!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop="skuId" label="skuId" width="150" align="center">
        </el-table-column>
        <el-table-column prop="proName" label="商品名称" align="center" min-width="200"></el-table-column>
        <el-table-column label="状态" width="250" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isShelves">已上架</el-tag>
            <el-tag v-else type="danger">已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="modelCode" label="型号" width="200" align="center"></el-table-column>
        <el-table-column prop="skuSpecs" label="规格" width="200" align="center"></el-table-column>


        <el-table-column label="可赚金额" prop="profitAmount" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;"> {{-->
          <!--              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scoped">
            <el-button @click="setSinglePrice(scoped.row)" type="primary" size="mini">设置分销价</el-button>
            <el-button @click="removeSingle(scoped.row)" type="primary" size="mini">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" :total="total"
                     :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
    </div>
    <el-dialog
        title="设置分销价"
        :visible.sync="singlePriceDialog"
        width="30%">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="分销价">
          <el-input v-model="priceData.Price" placeholder="审批人"></el-input>
          <p v-if="IsYKT" style="color: #F56C6C">分销价不可低于销售价{{priceData.SalePrice}}</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitSinglePrice">保存</el-button>
        </el-form-item>
      </el-form>
      <!--    <span slot="footer" class="dialog-footer">-->
      <!--    <el-button @click="singlePriceDialog = false">取 消</el-button>-->
      <!--    <el-button type="primary" @click="singlePriceDialog = false">确 定</el-button>-->
      <!--  </span>-->
    </el-dialog>
    <el-dialog
        title="批量设置分销价格"
        :visible.sync="MultiPriceDialog"
        width="60%">
      <el-table
          :data="MultiTableData"
          border
          style="width: 100%">
        <el-table-column
            prop="channelType"
            label="渠道"
            width="180">
        </el-table-column>
        <el-table-column
            prop="skuId"
            label="skuId"
            width="180">
        </el-table-column>
        <el-table-column
            prop="proName"
            label="商品名称">
        </el-table-column>
        <el-table-column
            prop="modelCode"
            label="型号">
        </el-table-column>
        <el-table-column
            prop="skuSpecs"
            label="规格">
        </el-table-column>
        <el-table-column
            prop="businessPrice"
            label="销售价">
        </el-table-column>
        <el-table-column
            label="分销价">
          <template slot-scope="scoped">
            <el-input v-model="scoped.row.distributionPrice"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="singlePriceDialog = false">取 消</el-button>-->
        <el-button :loading="multiSetLoading" v-preventClick type="primary" @click="multiSet">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        v-if="OwnProductDialog"
        title="从自有商品库导入"
        :visible.sync="OwnProductDialog"
        @close=closeOwn
        :close-on-click-modal="false"
        class="roll-dialog"
        width="80%">
      <el-form @submit.native.prevent inline label-width="85px">
        <el-form-item label="skuId:">
          <el-input v-model="selfData.SkuIds" placeholder="请输入SkuId"></el-input>
        </el-form-item>
        <el-form-item label="外部skuId:">
          <el-input v-model="selfData.RemoteIds" placeholder="请输入外部skuId"></el-input>
        </el-form-item>
        <el-form-item label="外部spuId:">
          <el-input v-model="selfData.remoteSpuIds" placeholder="请输入外部spuId"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input v-model="selfData.ProductName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="来源">
          <el-select @change="getOwnProList" style="margin-left:10px;margin-bottom:10px;" clearable
                     v-model="selfData.ResellerId " placeholder="请选择供应商">
            <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="display: flex;">
            <el-button :loading="ownButtonLoading" size="small" type="primary" @click="searchOwnFun">查询</el-button>
            <el-button size="small" @click="resetOwnFun">重置</el-button>
            <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
          </div>
        </el-form-item>
      </el-form>
      <div style="min-height:200px;overflow-y: scroll;">
        <el-form :rules="model.rules" :model="model" ref="form"></el-form>
        <el-table
            height="250"
            v-loading="ownLoading"
            :data="OwnTableData"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            @selection-change="selectOwnChange"
            border
            style="width: 100%">
          <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
          <el-table-column
              prop="productSkuId"
              label="skuId"
              width="80">
          </el-table-column>
          <el-table-column
              prop="remoteId"
              label="外部skuId"
              width="90">
          </el-table-column>
          <el-table-column
              prop="remoteSpuId"
              label="外部spuId"
              width="90">
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="resellerName"-->
          <!--              label="来源"-->
          <!--              width="180">-->
          <!--          </el-table-column>-->
          <el-table-column
              prop="productName"
              label="商品名称">
          </el-table-column>
          <el-table-column
              prop="productModel"
              label="型号">
          </el-table-column>
          <el-table-column
              prop="propertyCode"
              label="规格">
          </el-table-column>
          <el-table-column
              width="80"
              prop="marketPrice"
              label="销售价">
          </el-table-column>
          <el-table-column
              width="120"
              label="分销价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.Price"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper"
                         @size-change="handleSizeChange1"
                         @current-change="handleCurrentChange1" :total="total1"
                         :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="cancelOwn">取 消</el-button>-->
<!--        <el-button :loading="ownButtonLoading" v-preventClick type="primary" @click="confirmOwn">确认导入</el-button>-->
        <el-button v-preventClick type="primary" @click="confirmOwn">确认导入</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="从营客通商品库导入"
        @close=closeYKT
        :visible.sync="YKTDialog"
        :close-on-click-modal="false"
        width="60%">
      <el-form @submit.native.prevent inline label-width="70px">
        <el-form-item label="skuId:">
          <el-input v-model="YKTData.SkuIds" placeholder="skuId"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input v-model="YKTData.ProductName" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label="供应商">
          <el-select @change="getYKTProList" style="margin-left:10px;margin-bottom:10px;" clearable
                     v-model="YKTData.ResellerId " placeholder="商品名称">
            <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="类型">-->
        <!--          <el-input v-model="YKTData.orderNo" placeholder="营客通订单号"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="品牌">-->
        <!--          <el-input v-model="YKTData.orderNo" placeholder="营客通订单号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <div style="display: flex;">
            <el-button size="small" type="primary" @click="searchYKTFun">查询</el-button>
            <el-button size="small" @click="resetYKTFun">重置</el-button>
            <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
          </div>
        </el-form-item>
      </el-form>
      <div style="min-height:200px;overflow-y: scroll;">
        <el-table
            v-loading="YKTLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            :data="YKTTableData"
            border
            @selection-change="selectTKTChange"
            style="width: 100%">
          <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
          <el-table-column
              prop="skuId"
              label="skuId"
              width="180">
          </el-table-column>
          <el-table-column
              prop="proName"
              label="商品名称"
              width="180">
          </el-table-column>
          <el-table-column
              prop="modelCode"
              label="型号">
          </el-table-column>
          <el-table-column
              prop="skuSpecs"
              label="规格">
          </el-table-column>
          <el-table-column
              prop="typeName"
              label="类型">
          </el-table-column>
          <el-table-column
              prop="brandName"
              label="品牌">
          </el-table-column>
          <el-table-column
              prop="businessPrice"
              label="销售价">
          </el-table-column>
          <el-table-column
              label="分销价">
            <template slot-scope="scoped">
              <el-input v-model="scoped.row.Price"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper"
                         @size-change="handleSizeChange2"
                         @current-change="handleCurrentChange2" :total="total2"
                         :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="YKTCancel">取 消</el-button>-->
<!--        <el-button :loading="YKTButtonLoading" v-preventClick type="primary" @click="YKTConfirm">确认导入</el-button>-->
        <el-button v-preventClick type="primary" @click="YKTConfirm">确认导入</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="分销规则说明"
        :visible.sync="RuleDialog"
        width="40%">
      <el-form @submit.native.prevent label-width="100px">
        <el-form-item label="规则说明:">
          <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入内容"
              v-model="searchData.orderNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="RuleDialog = false">取 消</el-button>
        <el-button :loading="YKTButtonLoading" type="primary" @click="RuleDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import single from "echarts/src/coord/single/Single";
import {
  DistributionImport,
  DistributionImportList,
  DistributionList,
  DistributionRemove,
  DistributionSetPrice, ExportDistributionList, ExportDistributionOrderList,
  GetAllReseller, GetErpProductList,
  PropertyGroupCreate
} from "../../api/api";
import input from "element-ui/packages/input";

export default {
  name: "QuickSale",
  created() {
    // this.getList()
    this.getDistributorList();
  },
  methods: {
    selectOwnChange(val) {
      this.selectOwnRowData = val
      console.log('selectOwnRowData', this.selectOwnRowData)
    },
    selectTKTChange(val) {
      // console.log('val', val);
      // return;
      this.selectYKTRowData = val
      console.log('selectOwnRowData', this.selectOwnRowData)
    },
    closeOwn() {
      this.selfData.PageIndex = 1;
      this.selfData.PageSize = 10;
      this.selfData.ResellerId = null;
      this.selfData.SkuIds = '';
      this.selfData.RemoteIds = '';
      this.selfData.ProductName = '';
    },
    closeYKT() {
      this.YKTData.PageIndex = 1;
      this.YKTData.PageSize = 10;
      this.YKTData.ResellerId = null;
      this.YKTData.SkuIds = '';
      this.YKTData.ProductName = '';
    },
    getProList() {
      if (this.searchData.ResellerId) {
        this.getList()
      }
    },
    getOwnSource() {
      if (this.searchData.ResellerId) {
        this.getList()
      }
    },
    async multiSet() {
      console.log(111)
      // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
      // if (this.MultiTableData.some(item => !regex.test(item.distributionPrice))) {
      //   return this.$message.error('请输入正确的分销价格(大于等于200,最多保留两位小数)');
      // }

      let flag = true;
      this.MultiTableData.forEach(item =>{

        if (item.channelType === '营客通商品') {
          // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
          // if (!regex.test(item.distributionPrice)){
          //   flag = false
          // }
          console.log('item', item);
          console.log(item.distributionPrice, item.businessPrice)
          if (Number(item.distributionPrice) <= Number(item.businessPrice)){
            flag = false;
          }
        }
      })

      if (!flag) {
        // return this.$message.error('营客通设置分销价格(大于等于200,最多保留两位小数)')
        return this.$message.error('营客通商品分销价必须大于销售价')
      }

      let data = [];
      this.MultiTableData.forEach((row, index) => {
        // this.MultiTableData.push({Id: row.Id,Price: row.Price})
        data.push({Id: row.id, Price: row.distributionPrice})
      })


      this.multiSetLoading = true;
      try {
        let res = await DistributionSetPrice(data);
        if (res.data.success) {
          this.multiSetLoading = false;
          console.log('res', res);
          this.MultiPriceDialog = false;
          this.$message.success(res.data.result.msg)
          await this.getList();
        } else {
          this.multiSetLoading = false
          this.$message.error(res.data.error.message)
        }
        console.log('res', res)
      } catch (e) {
        this.multiSetLoading = false
      }

    },
    async getDistributorList() {
      let res = await GetAllReseller({PageIndex: 1, PageSize: 50});
      console.log('getDistributorList', res);
      if (res.data.success) {
        if (res.data.result.items.length > 0) {
          res.data.result.items.forEach((item) => {
            this.supplierList.push({id: item.id, name: item.name})
          })
          if (this.supplierList.length > 0) {
            this.searchData.ResellerId = this.supplierList[0].id
            await this.getList()
          }
        }
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    async getList() {
      this.tableLoading = true;
      let res = await DistributionList(this.searchData);
      console.log('res 分销列表', res);
      if (res.data.success) {
        this.tableLoading = false;
        this.tableList = res.data.result.data;
        this.total = res.data.result.dataCount;
      } else {
        this.tableLoading = false;
        this.$message.error(res.data.error.message)
      }
    },
    async importFromUs() {
      // if (!this.searchData.ResellerId) {
      //   return this.$message.error('请先选择对应的渠道供应商!')
      // }
      this.OwnProductDialog = true;
      this.selectOwnRowData = [];
      this.OwnTableData = [];
      this.selfData = {
        PageIndex: 1,
        PageSize: 10,
        ResellerId: null,
        ProductName: '',
        SkuIds: '',
        Sorting: '',
        SkipCount: '',
        MaxResultCount: '',
      }
      if (this.supplierList.length > 0) {
        this.selfData.ResellerId = this.supplierList[0].id
        await this.getOwnProList()
      }

      // await this.getOwnProList();
    },
    async getOwnProList() {
      if (!this.selfData.ResellerId) {
        return this.$message.error('来源为必选项!')
      }
      this.ownLoading = true;
      let SkipCount = (this.selfData.PageIndex - 1) * this.selfData.PageSize;
      this.selfData.SkipCount = SkipCount;
      this.selfData.MaxResultCount = this.selfData.PageSize;
      let res = await GetErpProductList(this.selfData);
      console.log('res.data.success', res);
      if (res.data.success) {
        this.ownLoading = false;
        if (res.data.result && res.data.result.items.length > 0) {
          res.data.result.items && res.data.result.items.forEach((item, index) => {
            item.Price = null
          })
          this.OwnTableData = res.data.result.items;
          this.total1 = res.data.result.totalCount;
        }
      } else {
        this.ownLoading = false;
        this.$message.error(res.data.error.message)
      }
      console.log('res', res);
    },
    async importFromYKT() {
      // if (!this.searchData.ResellerId) {
      //   return this.$message.error('请先选择对应的渠道供应商!')
      // }
      this.YKTTableData = [];
      this.selectYKTRowData = [];
      this.YKTDialog = true;
      this.YKTData = {
        PageIndex: 1,
        PageSize: 10,
        ResellerId: null,
        ProductName: '',
        SkuIds: '',
        SkipCount: '',
        MaxResultCount: '',
      }
      if (this.supplierList.length > 0) {
        this.YKTData.ResellerId = this.supplierList[0].id
        await this.getYKTProList()
      }
      // this.getYKTProList();
    },
    async getYKTProList() {
      if (!this.YKTData.ResellerId) {
        return this.$message.error('供应商为必选项!')
      }
      this.YKTLoading = true;
      let SkipCount = (this.YKTData.PageIndex - 1) * this.YKTData.PageSize;
      this.YKTData.SkipCount = SkipCount;
      this.YKTData.MaxResultCount = this.YKTData.PageSize;
      let res = await DistributionImportList(this.YKTData);
      console.log('res.data.success', res);
      if (res.data.success) {
        this.YKTLoading = false;
        if (res.data.result && res.data.result.data.length > 0) {
          res.data.result && res.data.result.data.forEach((item, index) => {
            item.Price = null
          })
          this.YKTTableData = res.data.result.data;
          this.total2 = res.data.result.totalCount;
        }
        // this.YKTDialog = true;
      } else {
        this.YKTLoading = false;
        this.$message.error(res.data.error.message)
      }
      console.log('res', res);
    },
    tellRule() {
      this.RuleDialog = true;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    batchDelete() {
      if (!this.currentRow.length) {
        return this.$message.error('请选择需要删除的数据')
      }
      this.$confirm("批量移除吗？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        let Idss = this.currentRow.map((row, i) => {
          return row.id
        });
        let Ids = Idss.join(',');
        console.log('ids', Ids)
        let res = await DistributionRemove({Ids});
        if (res.data.success) {
          this.$message.success(res.data.result.msg)
        } else {
          this.$message.error(res.data.error.message)
        }
        await this.getList();
      }).catch(() => {
      });
    },
    setPrice() {
      if (!this.currentRow.length) {
        return this.$message.error('请选择数据')
      }

      this.MultiTableData = this.currentRow;
      this.MultiPriceDialog = true;
    },
    exporting() {

      ExportDistributionList(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '分销sku列表.xlsx'  //后缀名一定要写对，不然会导致文件损坏，打不开
        a.href = objectUrl
        a.click()
        a.remove()
        console.log(res, '???????????')
      })
    },
    searchOwnFun() {
      if (!this.selfData.ResellerId) {
        return this.$message.error('请选择来源!')
      }
      this.getOwnProList();
    },
    searchYKTFun() {
      if (!this.YKTData.ResellerId) {
        return this.$message.error('请选择供应商!')
      }
      this.getYKTProList();
    },
    searchFun() {
      this.getList();
    },
    async YKTConfirm() {
      // console.log('selectYKTRowData', this.selectYKTRowData)
      // return;
      if (this.selectYKTRowData.length <= 0) {
        return this.$message.error('请选择需要导入的数据!')
      }
      let data = {};
      data.ResellerId = this.YKTData.ResellerId;
      // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
      // if (this.selectYKTRowData.some(item => !item.Price)) {
      //   return this.$message.error('请输入价格');
      // }
      this.YKTButtonLoading = true;
      let list = [];
      let flag = true;
      let flag1 = true;

      this.selectYKTRowData && this.selectYKTRowData.forEach((item, index) => {
          // let reg = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
          let reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
          if (!reg.test(item.Price)) {
            flag1 = false;
          }
      })
      console.log('flag1 = ' + flag1)
      if (!flag1) {
        return this.$message.error('请正确填写分销价(不能为空且不能低于销售价,最多保留两位小数)!')
      }



      this.selectYKTRowData && this.selectYKTRowData.forEach((item, index) => {
        if (item.Price){
          // let reg = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
          // console.log('reg', reg.test(item.Price))
          // console.log(item.Price, item.businessPrice)
          if (Number(item.Price) <= Number(item.businessPrice)){
           flag = false;
          }
        }
      })
      // console.log('flag', flag); return;
      if (!flag){
        return this.$message.error('营客通商品分销价必须大于销售价!')
      }
      // return;
      this.selectYKTRowData && this.selectYKTRowData.forEach((item, index) => {
        list.push({SkuId: Number(item.skuId), Price: Number(item.Price)})
      })
      data.detaiList = list;
      let res = await DistributionImport(data)
      if (res.data.success) {
        this.YKTDialog = false;
        this.YKTButtonLoading = false;
        await this.getList()
      } else {
        this.ownButtonLoading = false;
        this.$message.error(res.data.error.message)
      }
    },
    async confirmOwn() {

      console.log('selectOwnRowData', this.selectOwnRowData)
      if (this.selectOwnRowData.length <= 0) {
        return this.$message.error('请选择需要导入的数据!')
      }
      let data = {};
      data.ResellerId = this.selfData.ResellerId;
      let list = [];
      // let flag = true;
      // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
      // this.selectOwnRowData.forEach((item, index) => {
      //   if (!regex.test(item.Price)) {
      //     flag = false;
      //   }
      // })
      // if (!flag) {
      //   return this.$message.error('请输入正确的分销价格(大于等于200,最多保留两位小数)')
      // }

      // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
      // if (this.selectOwnRowData.some(item => !regex.test(item.Price))) {
      //   return this.$message.error('请输入正确的分销价格(大于等于200,最多保留两位小数)');
      // }
      this.ownButtonLoading = true;
      this.selectOwnRowData.forEach((item, index) => {
        list.push({SkuId: Number(item.remoteId), Price: Number(item.Price)})
      })
      data.detaiList = list;
      let res = await DistributionImport(data)
      if (res.data.success) {
        this.ownButtonLoading = false;
        this.OwnProductDialog = false;
        await this.getList()
      } else {
        this.ownButtonLoading = false;
        this.$message.error(res.data.error.message)
      }
    },
    YKTCancel() {
      this.YKTData.PageIndex = 1;
      this.YKTData.PageSize = 10;
      this.YKTData.SkuIds = '';
      this.YKTData.ProName = '';
      this.YKTData.ResellerId = null;
      this.OwnProductDialog = false;
    },

    cancelOwn() {
      this.selfData.PageIndex = 1;
      this.selfData.PageSize = 10;
      this.selfData.SkuIds = '';
      this.selfData.ProName = '';
      this.selfData.ResellerId = null;
      this.OwnProductDialog = false;
    },
    async resetYKTFun() {
      this.YKTData.PageIndex = 1;
      this.YKTData.PageSize = 10;
      this.YKTData.SkuIds = '';
      this.YKTData.ProductName = '';
      // this.YKTData.ResellerId = null;
      // this.searchData.ResellerId = null;
      // this.getList();
      if (!this.YKTData.ResellerId) {
        return this.$message.error('请选择供应商!')
      }
      await this.getYKTProList();
    },
    resetOwnFun() {
      this.selfData.PageIndex = 1;
      this.selfData.PageSize = 10;
      this.selfData.SkuIds = '';
      this.selfData.RemoteIds = '';
      this.selfData.remoteSpuIds = '';
      this.selfData.ProductName = '';
      // this.searchData.ResellerId = null;
      // this.getList();
      if (!this.selfData.ResellerId) {
        return this.$message.error('请选择来源!')
      }
      this.getOwnProList();
    },
    resetFun() {
      this.searchData.PageIndex = 1;
      this.searchData.PageSize = 10;
      this.searchData.SkuIds = '';
      // this.searchData.RemoteIds = '';
      this.searchData.ProName = '';
      this.searchData.ChannelType = '';
      this.searchData.IsShelves = null;
      // this.searchData.ResellerId = null;
      if (this.searchData.ResellerId) {
        this.getList();
      } else {
        return this.$message.error('请选择供应商!')
      }

    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getList();
    },
    handleSizeChange2(e) {
      this.YKTData.PageSize = e;
      this.getYKTProList();
    },
    handleSizeChange1(e) {
      this.selfData.PageSize = e;
      this.getOwnProList();
    },
    handleCurrentChange2(val) {
      this.YKTData.PageIndex = val;
      this.getYKTProList();
    },
    handleCurrentChange1(val) {
      this.selfData.PageIndex = val;
      this.getOwnProList();
    },
    setSinglePrice(row) {
      this.priceData.Id = row.id;
      this.priceData.Price = row.distributionPrice || '';
      this.priceData.SalePrice = row.businessPrice;
      this.IsYKT = row.channelType === '营客通商品';
      this.singlePriceDialog = true;
    },
    removeSingle(row) {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        let res = await DistributionRemove({Ids: row.id});
        if (res.data.success) {
          this.$message.success(res.data.result.msg)
          await this.getList();
        } else {
          this.$message.error(res.data.error.message)
        }
      }).catch(() => {
      });
    },
    onSubmitMultiPrice() {
      this.MultiPriceDialog = false;
    },
    onSubmitSinglePrice() {
      if (this.IsYKT) {
        // var regex = /^(?:[2-9]\d{2,}|[1-9]\d{3,})(?:\.\d{1,2})?$/;
        // if (!regex.test(this.priceData.Price)) {
        //   return this.$message.error('请输入正确的分销价格(大于等于200,最多保留两位小数)');
        // }
        if (Number(this.priceData.Price) <= Number(this.priceData.SalePrice)){
          return this.$message.error('营客通商品分销价设必须大于销售价')
        }
      }
      this.$confirm("确认保存吗？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        let list = [];
        list.push(this.priceData);
        let res = await DistributionSetPrice(list)
        if (res.data.success) {
          this.singlePriceDialog = false;
          this.getProList();
          this.$message.success(res.data.result.msg);
        } else {
          this.$message.error(res.data.error.message)
        }
      }).catch(() => {
      });
    },
  },
  data() {
    return {
      IsYKT:true,
      multiSetLoading: false,
      model: {
        rules: {}
      },
      singleRow:[],
      selectOwnRowData: [],
      selectYKTRowData: [],
      ownLoading: false,
      ownButtonLoading: false,
      YKTButtonLoading: false,
      YKTLoading: false,
      YKTData: {
        PageIndex: 1,
        PageSize: 10,
        ResellerId: null,
        ProductName: '',
        SkuIds: '',
        SkipCount: '',
        MaxResultCount: '',
      },
      selfData: {
        PageIndex: 1,
        PageSize: 10,
        ResellerId: null,
        ProductName: '',
        SkuIds: '',
        RemoteIds: '',
        remoteSpuIds: '',
        Sorting: '',
        SkipCount: '',
        MaxResultCount: '',
      },
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        SkuIds: null,
        // RemoteIds: null,
        ProName: null,
        ChannelType: null,
        IsShelves: null,
        ResellerId: null
      },
      currentRow: [],
      RuleDialog: false,
      OwnProductDialog: false,
      YKTDialog: false,
      MultiTableData: [],
      OwnTableData: [],
      YKTTableData: [],
      MultiPriceDialog: false,
      priceData: {
        Id: null,
        Price: '',
        SalePrice: '',
      },
      options: [{
        value: '1',
        label: '我的商品'
      }, {
        value: '2',
        label: '平台商品'
      }],
      options1: [{
        value: 'true',
        label: '上架'
      }, {
        value: 'false',
        label: '下架'
      }],
      singlePriceDialog: false,
      tableList: [],
      tableLoading: false,
      total: null,
      total1: null,
      total2: null,
      valueTime: [],
      supplierList: []
    }
  },
}
</script>


<style scoped>
</style>